import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiClock, FiAlertCircle } = FiIcons;

const TasksOverview = ({ tasks }) => {
  const tasksByStatus = {
    pending: tasks.filter(t => t.status === 'pending'),
    in_progress: tasks.filter(t => t.status === 'in_progress'),
    completed: tasks.filter(t => t.status === 'completed')
  };

  const statusConfig = {
    pending: {
      label: 'Pending',
      icon: FiClock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200'
    },
    in_progress: {
      label: 'In Progress',
      icon: FiAlertCircle,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    },
    completed: {
      label: 'Completed',
      icon: FiCheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200'
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Tasks Overview</h3>
      
      <div className="space-y-4">
        {Object.entries(tasksByStatus).map(([status, statusTasks]) => {
          const config = statusConfig[status];
          
          return (
            <motion.div
              key={status}
              whileHover={{ scale: 1.02 }}
              className={`p-4 rounded-lg border ${config.bgColor} ${config.borderColor}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={config.icon} className={`w-5 h-5 ${config.color}`} />
                  <span className="font-medium text-gray-900">{config.label}</span>
                </div>
                <span className={`text-xl font-bold ${config.color}`}>
                  {statusTasks.length}
                </span>
              </div>
              
              {statusTasks.length > 0 && (
                <div className="space-y-2">
                  {statusTasks.slice(0, 3).map(task => (
                    <div key={task.id} className="text-sm text-gray-600">
                      <span className="font-medium">{task.title}</span>
                      {task.priority === 'high' && (
                        <span className="ml-2 px-2 py-1 bg-red-100 text-red-600 rounded-full text-xs">
                          High Priority
                        </span>
                      )}
                    </div>
                  ))}
                  {statusTasks.length > 3 && (
                    <p className="text-xs text-gray-500">
                      +{statusTasks.length - 3} more tasks
                    </p>
                  )}
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default TasksOverview;